/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CustomerStatusEnum } from './customer-status-enum';
import { AddressRequest } from './address-request';

export interface ProfileUpdateRequest {
  address?: AddressRequest;
  customer_status?: CustomerStatusEnum;
  d_number?: string | null;
  pnr?: string | null;
  utl?: string | null;
  customer_status_explanation?: string | null;
}
export namespace ProfileUpdateRequest {}
